import { ProductMenu } from '../product-menu';
import { Type } from '@angular/core';
import { MenuHeaderTitleImageComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-title/menu-header-title-image/menu-header-title-image.component';
import { StrainType } from '../../enum/dto/strain-classification.enum';
import { ColumnGrouping } from '../section/column-grouping';
import { ColumnUtils } from '../../../utils/column-utils';
import { ProductMenuFooterComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-footer/product-menu-footer.component';
import { ClassificationFooterComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-footer/classification-footer/classification-footer.component';
import { Section } from '../section/section';
import { SectionRowViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import { SortVariantUtils } from '../../../utils/sort-variant-utils';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { SectionColumnViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { SectionColumnProductInfoType } from '../../enum/shared/section-column-product-info-type';
import { SectionColumnType } from '../../enum/shared/section-column-type';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class LuxLeafMenu extends ProductMenu {
  protected override deserializeSections() {
    super.deserializeSections();
    this.translateVariantClassificationsIntoHybridIndicaSativa(this.sections);
  }

  protected override deserializeTemplateSections() {
    super.deserializeTemplateSections();
    this.translateVariantClassificationsIntoHybridIndicaSativa(this.templateSections);
  }

  override getThemeClass(): string {
    return 'lux-leaf-theme';
  }

  override getHeaderType(): Type<MenuHeaderTitleImageComponent> {
    return MenuHeaderTitleImageComponent;
  }

  override getFooterType(): Type<ProductMenuFooterComponent> {
    return ClassificationFooterComponent;
  }

  override getShowFooter(): boolean {
    return true;
  }

  override getShouldInflateColumnHeaderForRow(
    s: Section,
    col: SectionColumnViewModel,
    rows: SectionRowViewModel[]
  ): boolean {
    return col?.columnType !== SectionColumnProductInfoType.StrainType;
  }

  override getSectionHeaderUnderlined(): boolean {
    return false;
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  override fixedLocationBadgesPropertyIsWithin(): WithinNameCell | null {
    return WithinNameCell.TitleLine;
  }

  override getShowProductSubtitle(): boolean {
    return false;
  }

  override getColumnOrdering(): Map<SectionColumnType, number> {
    return new Map<SectionColumnType, number>([
      [SectionColumnProductInfoType.StrainType, 1],
      [SectionColumnProductInfoType.ProductTitle, 2],
      [SectionColumnProductInfoType.Badge, 3],
      [SectionColumnProductInfoType.Brand, 4],
      [SectionColumnProductInfoType.Strain, 5],
      ...SectionColumnViewModel.getDefaultAdditionalDetailsColumnOrder(6),
      SectionColumnViewModel.getDefaultProductTagGroupColumnOrdering(7),
      ...SectionColumnViewModel.getDefaultCannabinoidColumnOrdering(8),
      ...SectionColumnViewModel.getDefaultTerpeneColumnOrdering(9),
      [SectionColumnProductInfoType.QuantityAndSize, 10],
      [SectionColumnProductInfoType.Quantity, 11],
      [SectionColumnProductInfoType.Size, 12],
      [SectionColumnProductInfoType.VariantType, 13],
      [SectionColumnProductInfoType.Stock, 14],
      [SectionColumnProductInfoType.GradingResults, 15],
      [SectionColumnProductInfoType.VariantPrice, 16],
      [SectionColumnProductInfoType.VariantSecondaryPrice, 17]
    ]);
  }

  override getUniqueClassificationList(): StrainType[] {
    const through = (c: StrainType, allowed: StrainType[]) => allowed?.includes(c);
    return super
      .getUniqueClassificationList()
      ?.filter(c => through(c, [StrainType.Hybrid, StrainType.Sativa, StrainType.Indica, StrainType.CBD]))
      ?.sort(SortVariantUtils.luxLeafStrainTypeSort);
  }

  override getLineModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }

  override getGridModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }

  override whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Karla.Bold_700, FONT.Karla.Medium_500, FONT.Karla.Regular_400, FONT.Karla.SemiBold_600];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/wis6ndl.css';
  }
}
